import React from "react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { formatString } from "@utils/dataformatter/Rawformatter";
import { useAxiosContext } from "@context/axiosinstance";
import { Portal } from "@radix-ui/react-portal";
import { useSidebar } from "@component/UI/sidebar";

// Floating container
export const FloatingContainer = ({ children, id,isbgVisible }) => {
  return (
    <div
      id={id}
      className="
				inline-flex items-center justify-center gap-1 mb-4
				px-7
			"
    >
      {children}
    </div>
  );
};

// Inner button component
export const InnerButton = ({
  id,
  lighten = false,
  disabled,
  tooltip = false,
  tooltipContent,
  isAuthenticated,
  className,
  children,
  ...props
}) => {

  const buttonContent = (
    <Button
      id={formatString(id)}
      disabled={disabled}
      className={cn(
        "text-sm font-medium px-4 py-2 h-7 rounded-lg transition-colors",
        lighten
          ? "bg-gray-100 text-black hover:bg-gray-200"
          : "bg-[#5776E7] text-white hover:bg-[#5776E7]/90",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      {...props}
    >
      {children}
    </Button>
  );

  if (tooltip && tooltipContent) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{buttonContent}</TooltipTrigger>
        <TooltipContent>
          <p>{tooltipContent}</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  return buttonContent;
};

// Floating button container
export const FloatingButtonContainer = ({
  id,
  children,
  isVisible,
  isAuthenticated = false,
  isbgVisible = false
}) => {
  const { mainRef } = useSidebar();

  return (
    isAuthenticated &&
    isVisible && (
      <Portal className={cn(
          "sticky bottom-1 flex justify-center transition-transform duration-300 z-[1]",
          isbgVisible &&
          "bg-white/10 backdrop-blur-md border border-gray-100 shadow-md rounded-2xl p-0 gap-6",
          `${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`
        )}
        container={mainRef.current}>
        <FloatingContainer id={"btn" + formatString(id)} isbgVisible={isbgVisible}>
          {children}
        </FloatingContainer>
      </Portal>
    )
  );
};
